"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkPhrase_1 = require("./checkPhrase");
const solveModules_1 = require("./solveModules");
const solve = (input) => {
    checkPhrase_1.checkInput(input);
    let result = solveModules_1.solveBetweenParantheses(input);
    result = solveModules_1.solveMathPhrases(result);
    return +result > 0 ? result.replace('+', '') : result;
};
exports.default = solve;
